import React, { useState } from "react";

const HexHover = (Component, Hex, origin = "#fff") => {
  return (props) => {
    const [isHover, setIsHover] = useState(false);
    const mouseEnterHandler = () => setIsHover(true);
    const mouseLeaveHandler = () => setIsHover(false);
    const { children, style: base, ...rest } = props;

    const style = {
      ...base,
      background: `${isHover ? Hex : origin}`,
      boxShadow: "0 0px 4px 0px rgba(0, 0, 0, 0.2)",
    };

    return (
      <button
        {...rest}
        style={style}
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        {children}
      </button>
    );
  };
};

export default HexHover;



// WEBPACK FOOTER //
// ./src/components/HexHover/index.js